import { Badge, Button } from 'antd';
import './events.css';
import { hasDatePassed } from '@utils/date-utils';
import { EventRoleStatus } from '@type/db-types';
import { readableDateTimeFromDate } from '@utils/date-utils';
import { isEventAdmin } from '@utils/shared-utils';
import useUser from '@hooks/useUser';
import { RegisterNowButton } from './RegisterNowButton';
import { RegisteredWrestlersButton } from './RegisteredWrestlersButton';
import EventIcon from '@mui/icons-material/Event';
import { Typography } from '@mui/material';
import { AttachMoney, PeopleOutline, Place } from '@mui/icons-material';

export default function EventCard({
    event,
    moreInfoAction,
}: {
    event: EventRoleStatus;
    moreInfoAction: () => void;
    selectedIds: string[];
}) {
    const { user } = useUser();

    const isAdmin = isEventAdmin(user, event.createdByUserId, event.membership);
    // FIXME: hook up registered user count to "seats left" below...

    if (!event) return null;

    return (
        <Badge.Ribbon
            text={hasDatePassed(event.startAt) ? 'Reg. closed' : 'Reg. open'}
            color={hasDatePassed(event.startAt) ? 'red' : 'green'}
        >
            <div className="event-card mb-3 h-100" onClick={moreInfoAction}>
                <div className="event-card-inner">
                    <div className="event-card-header">
                        <div className="event-name">
                            <h2>{event?.name}</h2>
                        </div>
                    </div>
                    <div className="event-card-time-location">
                        <Typography>
                            <EventIcon fontSize="small" />
                            {readableDateTimeFromDate(event.startAt)}
                        </Typography>
                        <Typography>
                            <Place fontSize="small" />
                            {event?.location}
                        </Typography>
                        <Typography>
                            <AttachMoney fontSize="small" />
                            {event?.fee} USD
                        </Typography>
                        {event?.maxEntries ? (
                            <Typography>
                                <PeopleOutline fontSize="small" />
                                {event.registrantsCount}/{event.maxEntries} Seats left
                            </Typography>
                        ) : null}
                    </div>
                    <div className="event-description mt-3">
                        <p>{event?.description}</p>
                    </div>
                    {/* <div className="organized-by">
                            Organize by: <span>{eventDetail?.manager?.user?.firstName} {eventDetail?.manager?.user?.lastName}</span>
                        </div> */}
                    <div className="event-action mt-3">
                        {event ? (
                            <>
                                <RegisterNowButton event={event} />
                                <RegisteredWrestlersButton event={event} />
                            </>
                        ) : null}
                        <Button
                            type={isAdmin ? 'primary' : 'link'}
                            className={`w-100  ${isAdmin ? 'btn-primary rounded-pill' : 'btn-link'}`}
                            onClick={moreInfoAction}
                        >
                            More information
                        </Button>
                    </div>
                </div>
            </div>
        </Badge.Ribbon>
    );
}
